import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ArrowUpRight, Loader2 } from "lucide-react";
import { QuoteFields, useQuoteForm } from "./Contact";

export const QuoteDialog = ({ open, onOpenChange }) => {
  const { form, set, submit, loading } = useQuoteForm();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="quote-dialog" className="max-w-2xl bg-bone border-0 p-8 sm:p-10">
        <DialogHeader>
          <span className="text-xs tracking-[0.28em] uppercase font-semibold text-royal">Request a quote</span>
          <DialogTitle className="font-display text-3xl sm:text-4xl tracking-tight text-royal-deep pt-2">
            Beyond Floors. <span className="italic text-royal">Beyond Expectations.</span>
          </DialogTitle>
        </DialogHeader>
        <div className="pt-4">
          <QuoteFields form={form} set={set} />
          <button
            data-testid="dialog-lead-submit"
            onClick={() => submit(() => onOpenChange(false))}
            disabled={loading}
            className="mt-8 w-full sm:w-auto group inline-flex items-center justify-center gap-2 bg-royal text-white text-sm font-medium pl-6 pr-5 py-3.5 rounded-full hover:bg-royal-dark transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            {loading ? "Sending..." : "Send request"}
            {!loading && <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
